import { render, staticRenderFns } from "./QuestionnaireChildrenSelectDialog.vue?vue&type=template&id=480613a6&scoped=true&"
import script from "./QuestionnaireChildrenSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireChildrenSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireChildrenSelectDialog.vue?vue&type=style&index=0&id=480613a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480613a6",
  null
  
)

export default component.exports